var _style, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClaimComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.56 32.3",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "claimcomplete"
  }, "Claim Complete Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "claimcomplete"
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n    .claimComplete1{fill:none;}.claimComplete2,.claimComplete3{fill:#2058b1;}.claimComplete3,.claimComplete4,.claimComplete6{fill-rule:evenodd;}.claimComplete4{fill:#73acf7;}.claimComplete5{fill:#225dbb;}.claimComplete6{fill:#1f58b7;}.claimComplete7{fill:#2f7bf5;fill-opacity:0.21;}.claimComplete8{fill:#86b8f8;}\r\n  ")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "claimComplete1",
    x: -839.63,
    y: -303.06,
    width: 1280,
    height: 1040
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "claimComplete2",
    d: "M27.37,13.88l-6.21-2.73a.42.42,0,0,0-.31,0l-6.21,2.73a.38.38,0,0,0-.23.35V22a.39.39,0,0,0,.21.35l6.21,3.17a.33.33,0,0,0,.17,0,.39.39,0,0,0,.18,0l6.2-3.13a.38.38,0,0,0,.22-.35V14.23A.38.38,0,0,0,27.37,13.88ZM21.11,12l5.21,2.34-5.21,2.34L19.75,16l2.06-.93a.39.39,0,0,0,0-.72l-1.65-.74a.34.34,0,0,0-.31,0l-2.71,1.21-1.24-.55ZM17.6,16l.85.32v1.59l-.85-.36ZM18,15.3l1.88-.78.68.28-1.87.78ZM15.26,15l1.58.68v2.24a.37.37,0,0,0,.22.35l1.58.79A.39.39,0,0,0,19,19a.39.39,0,0,0,.19-.33v-2l1.58.68v7.39l-5.53-2.79Zm6.17,9.78V17.35L27,15v7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "claimComplete3",
    d: "M12.85,1.72a.21.21,0,0,0-.21.2v.47a.21.21,0,0,0,.21.2.2.2,0,0,0,.2-.2V1.92a.2.2,0,0,0-.2-.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "claimComplete3",
    d: "M12.32,1.24h-.48a.2.2,0,0,0-.2.21.2.2,0,0,0,.2.2h.48a.2.2,0,0,0,.2-.2.2.2,0,0,0-.2-.21"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "claimComplete3",
    d: "M12.85.27a.21.21,0,0,0-.21.2V.94a.21.21,0,0,0,.21.2.2.2,0,0,0,.2-.2V.47a.2.2,0,0,0-.2-.2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "claimComplete3",
    d: "M13.85,1.21h-.47a.2.2,0,0,0-.2.2.2.2,0,0,0,.2.21h.47a.21.21,0,1,0,0-.41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "claimComplete3",
    d: "M35.58,26a.33.33,0,0,0-.32.34v.8a.34.34,0,0,0,.32.35.34.34,0,0,0,.32-.35v-.8a.33.33,0,0,0-.32-.34",
    "data-name": "Fill-6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "claimComplete3",
    d: "M34.7,25.16h-.8a.33.33,0,0,0-.34.32.33.33,0,0,0,.34.32h.8a.33.33,0,0,0,.34-.32.33.33,0,0,0-.34-.32",
    "data-name": "Fill-7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "claimComplete3",
    d: "M35.58,23.46a.33.33,0,0,0-.32.34v.8a.34.34,0,0,0,.32.35.34.34,0,0,0,.32-.35v-.8a.33.33,0,0,0-.32-.34",
    "data-name": "Fill-8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "claimComplete3",
    d: "M37.25,25.16h-.8a.33.33,0,0,0-.34.32.33.33,0,0,0,.34.32h.8a.34.34,0,0,0,.35-.32.34.34,0,0,0-.35-.32",
    "data-name": "Fill-9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "claimComplete3",
    d: "M2,21.75s.27,2-2,1.94c0,0,2,0,1.93,1.88a2.26,2.26,0,0,1,2-1.79s-1.54.35-1.9-2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "claimComplete4",
    d: "M33.68,7.71s.27,2-2,1.94c0,0,2,0,1.94,1.88a2.23,2.23,0,0,1,2-1.79s-1.54.35-1.9-2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "claimComplete4",
    d: "M11.68,29.63a1,1,0,0,1-1.1,1.08,1,1,0,0,1,1,1,1.24,1.24,0,0,1,1.08-1s-.83.19-1-1.13"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "claimComplete3",
    d: "M5.76,12.61s.09.69-.71.67c0,0,.69,0,.67.66a.79.79,0,0,1,.7-.63s-.54.12-.66-.7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "claimComplete3",
    d: "M39.8,16.44s.09.69-.71.67c0,0,.69,0,.67.65a.79.79,0,0,1,.7-.62s-.54.12-.66-.7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "claimComplete5",
    d: "M.47,6A.53.53,0,0,1,.47,5,.53.53,0,0,1,.47,6Zm0-.85a.32.32,0,0,0-.32.32.33.33,0,0,0,.32.32.32.32,0,0,0,.32-.32A.32.32,0,0,0,.47,5.16Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "claimComplete2",
    d: "M8.34,15.33a9.48,9.48,0,0,0-.1,1.3.45.45,0,0,0,.48.44.47.47,0,0,0,.48-.43,9.71,9.71,0,0,1,.1-1.2A.45.45,0,0,0,8.88,15a.48.48,0,0,0-.54.38Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "claimComplete6",
    d: "M20.58,5.37a12.28,12.28,0,0,0-7.42,2.47l.58-1.5a.47.47,0,0,0-.22-.58h0A.38.38,0,0,0,13,6L11.94,8.69a.44.44,0,0,0,0,.32v.07a.48.48,0,0,0,.48.41h2.84a.37.37,0,0,0,.37-.36.09.09,0,0,0,0-.05.48.48,0,0,0-.48-.42H13.69a11.37,11.37,0,1,1,6.89,20.42h0A11.35,11.35,0,0,1,9.23,18.41v-.06h0a.49.49,0,0,0-.52-.46h0a.47.47,0,0,0-.43.46h0s0,0,0,.06h0v.05a12.3,12.3,0,0,0,3.57,8,12.16,12.16,0,0,0,8.7,3.61h0a12.34,12.34,0,1,0,0-24.68Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "claimComplete7",
    d: "M18,20.33l.09-1.6-1-.51a.37.37,0,0,1-.22-.35V15.63l-1.17-.51L15.26,15v6.93l3,1.51A11.27,11.27,0,0,1,18,20.33Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "claimComplete7",
    d: "M18.14,17.57c0-.79.3-.5.27-1.22l-.1-.07L17.6,16v1.55l.53.23Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "claimComplete8",
    d: "M23.47,21.8l-1.42.85a.46.46,0,0,0-.16.57.33.33,0,0,0,.48.19l1.42-.85a.47.47,0,0,0,.15-.57A.32.32,0,0,0,23.47,21.8Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "claimComplete8",
    d: "M22.21,21.75a.29.29,0,0,0,.16,0l1.41-.85a.46.46,0,0,0,.16-.57.33.33,0,0,0-.48-.19L22.05,21a.45.45,0,0,0-.19.48.38.38,0,0,0,.35.32Z",
    "data-name": "Path"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "claimComplete7",
    d: "M18,15.3l.69.28,1.81-.75,0,0-.64-.27Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "claimComplete7",
    d: "M21.11,12,15.9,14.31l1.24.55,2.71-1.21a.34.34,0,0,1,.31,0l.9.4a20.16,20.16,0,0,1,1.44-1.46Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimComplete);
export default __webpack_public_path__ + "static/media/claim-complete.2b10350b578b4b84fcded4216cbc05ec.svg";
export { ForwardRef as ReactComponent };